import FitText from '@kennethormandy/react-fittext'
import imageUrlBuilder from '@sanity/image-url'
import slugify from '@sindresorhus/slugify'
import React from 'react'
import { withSiteData } from 'react-static'
import styled from 'styled-components'
import { Cell, Flex, StyledAnchor } from '../../styles/styled-common'

const StyledCell = styled(Cell)`
  text-align: center;
  font-size: 14px;
  color: ${p => p.theme.textOffwhite};
  width: 100%;
  img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
  }
`

const InnerCell = styled(Flex)`
  height: 100%;
  width: 100%;
  align-content: center;
`

const A = styled(StyledAnchor)`
  height: 100%;
  width: 100%;
`

const Img = styled.img`
  max-height: 55px;
`

let affiliated = []

class ProviderCell extends React.PureComponent {
  constructor(props) {
    super(props)

    this._builder = imageUrlBuilder(props.siteData.sanityConfig)
  }
  componentDidMount() {
    if (this.img && this.img.complete) {
      this._addAffiliated()
    }
  }

  _addAffiliated = () => {
    affiliated.push(this.props.host.id)
  }

  render() {
    const {
      affiliateUrl,
      id,
      logo,
      name,
      siteData: { site },
      fitText = true,
      ...props
    } = this.props

    const compressor = fitText === true ? 0.9 : fitText

    const track = ~affiliated.indexOf(id) ? null : (
      <Img
        ref={img => {
          this.img = img
        }}
        src={affiliateUrl}
        onLoad={this._addAffiliated}
        onError={this._addAffiliated}
        width={1}
        height={1}
        style={{ position: 'absolute', marginTop: -20000 }}
      />
    )

    return (
      <StyledCell {...props}>
        {/* {track} */}
        <A href={`/hosts/${slugify(name)}`}>
          <InnerCell flexDirection="column">
            <Img
              src={this._builder
                .image(logo)
                .height(55)
                .url()}
              alt={`${name} ${site.game.name} server host logo`}
            />
            <div style={{ alignSelf: 'stretch', lineHeight: 2 }}>
              <FitText style={{ width: '100%' }} compressor={compressor || 0}>
                {name}
              </FitText>
            </div>
          </InnerCell>
        </A>
      </StyledCell>
    )
  }
}

export default withSiteData(ProviderCell)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/ProviderCell.jsx